import { RESET_TOAST_NOTIFICATION } from "../../../constants/action-types/common/notification";

export const resetToast = ()=> ({ type: RESET_TOAST_NOTIFICATION });